import { fetchChildrenDimension } from "../../../api/object/Dimensions";
import { DimensionDetails } from "../../interfaces/CoObject";

export const getOriginalDimensionFromFather = async (item: DimensionDetails, dbId: string) => {
  const dValue = item.values[0];

  const composedOidPath = dValue.oidPath;
  if (item.hierarchy) composedOidPath.unshift(item.hierarchy.oid);
  composedOidPath.unshift(item.dimensionOid);

  const fatherOid = composedOidPath[composedOidPath.length - 2];
  if (!fatherOid?.length) return;
  const siblings = await fetchChildrenDimension(dbId, fatherOid);
  return siblings?.find((s) => s.oid === dValue.oid);
};
